/**
 * Which pages search engines may index: a studio's public pages [F32], and the main site pages [F35].
 *
 * Three readers share this one copy of the rule: the Vue app (Mana lapa switch, OrganizationLayout
 * and App.vue robots tags), the Cloudflare Pages Function that writes robots into the HTML [F35],
 * and the `node --test` regression tests. Keep its imports to modules with no Vue or webpack in them:
 * the Pages bundler and Node load it as it is, so the page and the server cannot disagree.
 */
import { NON_INDEXED_MAIN_PATHS } from '../../router/mainPaths.js'
import { splitLocale } from './canonicalUrl.js'

/** frontend_settings key. A missing key means the studio never chose. */
export const FRONTEND_SETTING_SEARCH_INDEXING_ENABLED = 'search_indexing_enabled'

/** Product decision 2026-10-02: a studio page is public, so it is indexable unless the studio switches it off. */
export const SEARCH_INDEXING_ENABLED_BY_DEFAULT = true

/** robots value for a page search engines must not index; links on it may still be followed. */
export const ROBOTS_NOINDEX = 'noindex,follow'

/** robots value for a page search engines may index. */
export const ROBOTS_INDEX = 'index,follow'

/**
 * @param {Object} organization public or private organization DTO
 * @returns {boolean} false for a missing organization — nothing to index
 */
export function isSearchIndexingEnabled (organization) {
  if (!organization) return false
  const value = organization.frontend_settings?.[FRONTEND_SETTING_SEARCH_INDEXING_ENABLED]
  return typeof value === 'boolean' ? value : SEARCH_INDEXING_ENABLED_BY_DEFAULT
}

/**
 * @param {string} pathname URL path, with or without a locale prefix
 * @returns {boolean} false for a main page listed in NON_INDEXED_MAIN_PATHS (the legal pages);
 *   true for every other path — studio pages decide with isSearchIndexingEnabled
 */
export function isMainPageIndexed (pathname) {
  return !NON_INDEXED_MAIN_PATHS.includes(splitLocale(pathname).path.slice(1))
}
